export * from "./Criterion";
export * from "./PedagogicalYear";
export * from "./Permission";
export * from "./Request";
export * from "./User";
export * from "./Person";
export * from "./Institution";
export * from "./EAuthorization";
export * from "./Enrollment";
export * from "./Benefit";
export * from "./Beneficiary";
export * from "./ErrorMessage";